module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAASFBMVEUAAABnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqwauUnIAAAAF3RSTlMA4e1RNiqQ061yWEvl2bmleG4v8WIbGd/4OowAAABxSURBVDjL7dO7DoAgDEDRogICCooP/v9PNSQGk4J1c5A7teSMFGqlprFBSaRUyDQgJnOMIcbi+8y5i4PlXJeZARBx6AF8mbU31lFMLG/YCiZYkqlz045ie1w3gl1V9h0zkPJPvzelM4y+Bfqy6Dv9XQceWxfq+gtQ2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_ico7.png
// module id = i7XF
// module chunks = 1